const getMedia = gallery => {
  if (!gallery) {
    return;
  }
  const media = {
    items: gallery?.map(item => {
      const mediaItem = item[0];
      if (mediaItem.original) {
        return {
          src: mediaItem?.desktop?.url,
          srcTablet: mediaItem?.tablet?.url,
          srcMobile: mediaItem?.mobile?.url,
          type: 'IMAGE',
          copyright: {
            title: mediaItem.title,
            copyright: mediaItem.copyright
          }
        };
      }
      return {
        src: mediaItem.url,
        type: 'VIDEO',
        imagePlaceholder: mediaItem.teaser_image[0]?.desktop?.url,
        imagePlaceholderTablet: mediaItem.teaser_image[0]?.tablet?.url,
        imagePlaceholderMobile: mediaItem.teaser_image[0]?.mobile?.url,
        copyright: {
          titleVideo: mediaItem.title,
          copyrightVideo: mediaItem.copyright,
          title: mediaItem.teaser_image[0]?.title,
          copyright: mediaItem.teaser_image[0]?.copyright
        },
        start_second: mediaItem.start_second,
        stop_second: mediaItem.stop_second
      };
    }),
    autoplay: false
  };
  return media;
};
export const formatSIAPageCT = page => {
  const page_lead = page.sia_page_lead ? page.sia_page_lead[0] : '';
  const page_bottom = page.page_bottom ? page.page_bottom : [];
  const page_sub_lead = page.sia_page_sublead || [];
  const errors = [];
  const media = getMedia(page.sia_page_gallery);
  return {
    errors,
    title: page.title,
    page_top: {
      page_lead,
      page_sub_lead,
      media,
      bgColor: page.background_color?.name || 'SIAwhite'
    },
    page_bottom,
    section: page.section,
    content_type: page.content_type
  };
};
export const formatEventOccurrence = event => {
  const media = getMedia(event.event_data.pictures_gallery);
  const get_unique_locations = event => {
    const locations = new Set();
    if (event.event_generic_location) {
      locations.add(event.event_generic_location.name);
    }
    event.date_times.forEach(date_time => {
      if (date_time.event_generic_location) {
        locations.add(date_time.event_generic_location.name);
      }
    });
    return Array.from(locations);
  };
  const event_locations = get_unique_locations(event);
  return {
    hash: event.hash,
    occurence_code: event.occurence_code,
    date_times: event.date_times,
    content_type: event.content_type,
    event_format: event.format.name,
    event_status: event.event_occurrence_status,
    event_organisator: {
      id: event.event_data.event_organisator.id,
      label: event.event_data.event_organisator.name
    },
    event_locations: event_locations,
    languages: event.event_data.language,
    title: event.event_data.title,
    event_lead: event.event_data.event_lead,
    event_sublead: event.event_data.event_sublead,
    event_content: event.event_data.event_content,
    pictures_gallery: media?.items,
    partners: Object.assign(event.event_data.event_partner?.map(partner => ({
      src: partner.logo?.values?.[0]?.desktop?.url || '',
      href: partner.url?.url || '',
      width: '100%',
      height: 'auto'
    })) || []),
    event_price: event.event_price || [],
    speaker: event.speaker,
    media: media?.items,
    event_occurrences: event.sia_event_occurrences,
    related_events: event.related_events
  };
};
export const formatOrgaEvent = event => {
  const media = getMedia(event?.pictures_gallery);
  const get_unique_locations = event => {
    const locations = new Set();
    if (event.event_generic_location) {
      locations.add(event.event_generic_location.name);
    }
    event?.date_times.forEach(date_time => {
      if (date_time.event_generic_location) {
        locations.add(date_time.event_generic_location.name);
      }
    });
    return Array.from(locations);
  };
  const event_locations = get_unique_locations(event) || [];
  return {
    hash: event.hash,
    occurence_code: event.title,
    date_times: event.date_times,
    content_type: event.content_type,
    event_format: event.format.name,
    event_status: event.event_occurrence_status,
    event_organisator: event?.event_organisator.name || '',
    event_locations: event_locations,
    languages: event?.language,
    title: event.title,
    event_lead: event.lead,
    event_sublead: event?.sia_page_sublead || '',
    event_content: event?.event_content || '',
    pictures_gallery: media?.items,
    partners: Object.assign(event.event_collaboration?.map(partner => ({
      src: partner.logo?.values?.[0]?.desktop?.url || '',
      href: partner.url?.url || '',
      width: '100%',
      height: 'auto'
    })) || []),
    event_price: event.event_price || [],
    speaker: event.speaker,
    media: media?.items,
    event_occurrence_status_label: event?.event_occurrence_status_label,
    theme: event?.sia_core_topics?.map(el => ({
      label: el.name,
      id: el.id
    }))
  };
};
export const formatOrganization = event => {
  const media = getMedia(event.event_data.pictures_gallery);
  const event_price = event.event_price ? event.event_price : [];
  const get_unique_locations = event => {
    const locations = new Set();
    if (event.event_generic_location) {
      locations.add(event.event_generic_location.name);
    }
    event.date_times.forEach(date_time => {
      if (date_time.event_generic_location) {
        locations.add(date_time.event_generic_location.name);
      }
    });
    return Array.from(locations);
  };
  const event_locations = get_unique_locations(event);
  return {
    hash: event.hash,
    occurence_code: event.occurence_code,
    date_times: event.date_times,
    content_type: event.content_type,
    event_format: event.format.name,
    event_status: event.event_occurrence_status,
    event_organisator: event.event_data.event_organisator.name,
    event_locations: event_locations,
    languages: event.event_data.language,
    title: event.event_data.title,
    event_lead: event.event_data.event_lead,
    event_sublead: event.event_data.event_sublead,
    event_content: event.event_data.event_content,
    pictures_gallery: media?.items,
    partners: Object.assign(event.event_data.event_partner?.map(partner => ({
      src: partner.logo?.values?.[0]?.desktop?.url || '',
      href: partner.url?.url || '',
      width: '100%',
      height: 'auto'
    })) || []),
    event_price: event_price,
    speaker: event.speaker,
    media: media?.items
  };
};
export const formatMenuItems = (data, history, language) => {
  const formatItem = item => {
    const key = item.alias ? `/${language}/cms${item.alias}` : `/${language}${item.url}`;
    if (item.children?.length > 0) {
      return {
        title: item.title,
        children: item.children.sort((el, el2) => parseInt(el.weight) - parseInt(el2.weight)).map(formatItem).filter(el => el.children?.length > 0 || el.action !== undefined)
      };
    }
    return {
      title: item.title,
      id: item.target_node_id,
      basePath: item.basePath,
      alias: item.alias,
      alias_de: item.alias_de,
      alias_fr: item.alias_fr,
      alias_it: item.alias_it,
      alias_en: item.alias_en,
      to: item.url?.includes('https:') ? item.url : key,
      action: item.url?.length > 0 ? () => {
        if (item.url.includes('https:')) {
          window.open(item.url, '_blank').focus();
        } else {
          history.push(key);
        }
      } : undefined
    };
  };
  const menuItems = data.sort((el, el2) => parseInt(el.weight) - parseInt(el2.weight)).map(formatItem).filter(el => el.children?.length > 0 || el.action !== undefined);
  return {
    menuItems
  };
};
export const formatEventOccurrenceItem = (item, translate) => {
  const times = item.date_times;
  const month_number = times[0]?.date[0]?.split('-')[1];
  const event = item.occurrence_event_code && item.occurrence_event_code[0];
  const locations = times ? times.filter(el => el.generic_location)?.map(el => {
    return {
      id: el.generic_location_id,
      label: el.generic_location
    };
  }).filter((item, index, self) => index === self.findIndex(t => t.id === item.id)) : [];
  return {
    ...item,
    organisator: item.event_organisator ? item.event_organisator : event?.event_organisator && {
      id: event?.event_organisator[0]?.id,
      label: event?.event_organisator[0]?.name
    },
    locations,
    languages: event?.language && event?.language.map(el => {
      return {
        id: el.event_lang_code,
        label: el.name
      };
    }),
    occurence_suffix: item.occurence_suffix && item.occurence_suffix[0],
    name: (item?.title || '') + (event?.title || '') + (event?.event_lead || '') + (event?.event_sublead || '') + (item.occurence_code && item.occurence_code[0] || ''),
    title: event?.title,
    theme: event?.sia_core_topics?.map(el => ({
      label: el.name,
      id: el.id
    })),
    month: {
      id: month_number,
      label: translate(`cms.agenda.month.${month_number}`)
    },
    type: item.format && {
      label: item.format[0]?.name,
      id: item.format[0]?.id
    },
    partner: event?.event_partner && {
      id: event?.event_partner[0]?.id,
      label: event?.event_partner[0]?.name
    },
    code: item.occurence_code && item.occurence_code[0],
    date_seconds: new Date(times[0]?.date[0]).getTime() / 1000,
    status: event?.event_occurrence_status || item?.event_occurrence_status,
    status_label: item?.event_occurrence_status_label
  };
};
export const formatOrgaEventItem = (item, translate) => {
  const times = item.date_times;
  const month_number = times[0]?.date[0]?.split('-')[1];
  const locations = times ? times.filter(el => el.generic_location)?.map(el => {
    return {
      id: el.generic_location_id,
      label: el.generic_location
    };
  }).filter((item, index, self) => index === self.findIndex(t => t.id === item.id)) : [];
  return {
    ...item,
    organisator: {
      label: item.event_organisator,
      id: item.event_organisator
    },
    locations,
    language: item?.language,
    languages: item?.language && item?.language.map(el => ({
      id: el.event_lang_code,
      label: el.name
    })),
    occurence_suffix: item.occurence_suffix && item.occurence_suffix[0],
    name: (item?.title || '') + (item?.lead || '') + (item?.event_sublead || ''),
    title: item?.title,
    theme: item?.sia_core_topics?.map(el => ({
      label: el.name,
      id: el.id
    })),
    month: {
      id: month_number,
      label: translate(`cms.agenda.month.${month_number}`)
    },
    type: item.format && {
      label: item.format[0]?.name,
      id: item.format[0]?.id
    },
    partner: item?.event_partner && {
      id: item?.event_partner[0]?.id,
      label: item?.event_partner[0]?.name
    },
    code: item.event_code && item.event_code[0],
    date_seconds: new Date(times[0]?.date[0]).getTime() / 1000,
    status: item?.event_occurrence_status,
    status_label: item?.event_occurrence_status_label,
    event_occurrence_status_label: item?.event_occurrence_status_label
  };
};
export const formatExternalEvent_SIAEventItem = (item, translate) => {
  const times = item.date_times;
  const month_number = times[0]?.date[0]?.split('-')[1];
  const locations = times ? times.filter(el => el.generic_location)?.map(el => {
    return {
      id: el.generic_location_id,
      label: el.generic_location
    };
  }).filter((item, index, self) => index === self.findIndex(t => t.id === item.id)) : [];
  return {
    ...item,
    organisator: typeof item.event_organisator === 'string' ? {
      id: item.event_organisator,
      label: item.event_organisator
    } : item.event_organisator?.length > 0 ? {
      id: item.event_organisator[0].id,
      label: item.event_organisator[0].name
    } : null,
    locations,
    language: item?.language,
    languages: item?.language,
    occurence_suffix: item.occurence_suffix && item.occurence_suffix[0],
    name: item?.title || '',
    title: item?.title,
    theme: item?.sia_core_topics?.map(el => ({
      label: el.name,
      id: el.id
    })),
    month: {
      id: month_number,
      label: translate(`cms.agenda.month.${month_number}`)
    },
    type: item.format && {
      id: item.format[0]?.id,
      label: item.format[0]?.name
    },
    partner: item?.event_partnership_discount && {
      id: item?.event_partnership_discount[0]?.id,
      label: item?.event_partnership_discount[0]?.name
    },
    code: item.occurence_code && item.occurence_code[0] || item.title,
    date_seconds: new Date(times[0]?.date[0]).getTime() / 1000,
    status: item?.event_occurrence_status
  };
};
export const formatAgendaItem = (item, translate) => {
  let formattedItem = null;
  switch (item.content_type) {
    case 'external_event':
    case 'sia_event':
      formattedItem = formatExternalEvent_SIAEventItem(item, translate);
      break;
    case 'event_occurrence':
      formattedItem = formatEventOccurrenceItem(item, translate);
      break;
    case 'organisation_event':
      formattedItem = formatOrgaEventItem(item, translate);
      break;
    default:
      formattedItem = formatEventOccurrenceItem(item, translate);
      break;
  }
  return formattedItem;
};
export const formatAgenda = (data, translate) => {
  const items = data.map(item => formatAgendaItem(item, translate));
  const response = {
    event_occurrences: items,
    ...getAgendaFilters(items)
  };
  return response;
};
const getAgendaFilters = items => {
  const languages = items.map(item => item.languages).filter(item => !!item).flat().filter(item => item?.id).filter((item, index, self) => index === self.findIndex(t => t.id === item.id));
  const locations = items.map(item => item.locations).filter(item => !!item).flat().filter(item => item?.id).filter((item, index, self) => index === self.findIndex(t => t.id === item.id));
  const types = items.map(item => item.type).filter(item => item?.id).filter((item, index, self) => index === self.findIndex(t => t.id === item.id));
  const partners = items.map(item => item.partner).filter(item => item?.id).filter((item, index, self) => index === self.findIndex(t => t.id === item.id));
  const months = items.map(item => item.month).filter(item => item?.id).filter((item, index, self) => index === self.findIndex(t => t.id === item.id));
  const themes = items.map(item => item.theme).filter(item => !!item).flat().filter(item => item?.id).filter((item, index, self) => index === self.findIndex(t => t.id === item.id));
  const organisators = items.map(item => item.organisator).filter(item => item?.id).filter((item, index, self) => index === self.findIndex(t => t.id === item.id));
  return {
    organisators,
    languages,
    locations,
    themes,
    months,
    types,
    partners
  };
};